export const PaymentMethod = {
  crypto: 'crypto',
  creditCard: 'creditCard'
};
